import React, { useContext, useEffect, useState } from 'react';
import { ChatComponent } from '../components/ChatComponent';
import { SessionContext } from '../contexts/SessionContext';
import { APIContext } from '../contexts/APIContext';
import { PAGE_VIEW } from '../types';
import { LeftNavbar } from '../components/LeftNavbar';
import { LandingPage } from '../components/LandingPage';
import { joinClassnames, fetchSurveyMaster } from '../utils';
import { Header } from '../components/Header';
import FeedbackComponent from '../components/FeedbackComponent';
import { EventDelegationComponent } from '../components/EventDelegationComponent';
import AuthorisationError from '../components/AuthorisationError';
import AxiosInstance from '../axiosInstance';
import { AxiosError } from 'axios';
import { LoaderPage } from './LoaderPage';
import { msalInstance } from '..';
import UploadTranscript from '../components/UploadTranscript';
import { getValidToken } from '../utils';

export const HomePage = (props: any) => {
  const { pageView, isUpdatingChatHistory } = useContext(SessionContext);
  const {
    WBUId,
    expiryFlag,
    websocketConnected,
    accounts,
    websocketConnectionRef: { current: websocket },
    isAuthorized,
    setIsAuthorized,
    setARCGrowthAdminUser,
  } = useContext(APIContext);
  const [toggleSideBar, setToggleSideBar] = useState<boolean>(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState<boolean>(true);

  useEffect(() => {
    const fetchSecurityGroupData = async () => {
      try {
        await msalInstance.initialize();
        const response = await AxiosInstance.get(process.env.REACT_APP_SECURITY_GROUP);
        const ARCGrowthUser = response.data.accessRoleSwitchList;
        const hasARCGrowthUser = ARCGrowthUser.some((role: any) => role.Name === 'ARCGrowthUser');
        const hasARCGrowthAdminUser = ARCGrowthUser.some((role: any) => role.Name === 'ARCGrowthAdminUser');
        setARCGrowthAdminUser(hasARCGrowthAdminUser);
        console.log('ARCGrowthUser', ARCGrowthUser, response);
        if (hasARCGrowthUser) {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
        }
      } catch (error) {
        const axiosError = error as AxiosError;

        if (
          axiosError.response?.status === 401 &&
          axiosError.response?.data === 'Accenture.OAAA.LogManager.FaultCollection'
        ) {
          setIsAuthorized(false);
        }
      } finally {
        setIsCheckingAuth(false);
      }
    };
    fetchSecurityGroupData();
  }, []);

  useEffect(() => {
    if (websocketConnected && isAuthorized) {
      (async () => {
        const token = await getValidToken();
        fetchSurveyMaster(accounts, websocket, token);
      })();
    }
  }, [websocketConnected]);

  return (
    <>
      <EventDelegationComponent>
        {WBUId !== '' && window.self !== window.top ? null : <Header />}
        {isCheckingAuth ? (
          <LoaderPage />
        ) : !isAuthorized || expiryFlag === false ? (
          <div className="authorization-page-wrapper">
            <AuthorisationError />
          </div>
        ) : expiryFlag && websocketConnected ? (
          <div
            className={`page-container flex flex-row  relative ${
              WBUId !== '' && window.self !== window.top ? 'mt-[0px] h-screen' : 'mt-[54px] h-[calc(100vh-54px)]'
            }`}
          >
            {/* loading screen when chat history is updating */}
            {isUpdatingChatHistory.state && <LoaderPage />}

            {/* Left Navbar */}
            <div className={`tablet:block ${toggleSideBar ? 'block' : 'hidden'}`}>
              <LeftNavbar toggleSideBarHandler={setToggleSideBar} />
            </div>
            {pageView === PAGE_VIEW.LANDING && (
              <div className="text-white w-8 h-8 absolute top-4 left-3" onClick={() => setToggleSideBar(true)}>
                <img className="w-full h-full" src={'/icons/hamburger.svg'} alt={'chat history icon'} />
              </div>
            )}

            {/* Landing Page - using display none to hide/show component to not lose state of the chat (need to performance test this with longer chats) */}
            <div
              // className={joinClassnames(
              //   'landing-page-wrapper w-[calc(100%-72px)] h-full',
              //   pageView === PAGE_VIEW.LANDING ? 'flex flex-row' : 'hidden'
              // )}
              className={joinClassnames(
                'w-full tablet:ml-[64px]',
                pageView === PAGE_VIEW.LANDING ? 'flex flex-col tablet:flex-row' : 'hidden'
              )}
            >
              <LandingPage />
            </div>

            {/* Chat - using display none to hide/show component to not lose state of the chat (need to performance test this with longer chats) */}
            <div
              // className={joinClassnames(
              //   'chat-page-wrapper w-[calc(100%-72px)] h-full',
              //   pageView !== PAGE_VIEW.LANDING ? 'flex flex-row' : 'hidden'
              // )}
              className={joinClassnames(
                'chat-page-wrapper w-[calc(100%-50px)] ml-[64px] tb:overflow-hidden tb:ml-0 tb:w-full',
                pageView == PAGE_VIEW.CHAT ? 'flex flex-row' : 'hidden',
                WBUId !== '' && window.self !== window.top ? 'mr-[14px]' : ''
              )}
            >
              <ChatComponent toggleSideBarHandler={setToggleSideBar} />
            </div>
            <div
              className={joinClassnames(
                'feedback-page-wrapper w-[100%] ml-[4rem]',
                pageView === PAGE_VIEW.HELP ? 'flex flex-row' : 'hidden'
              )}
            >
              {pageView === PAGE_VIEW.HELP && <FeedbackComponent />}
            </div>
            <div className="bg-[#fff] flex flex-col flex-1">
              {pageView === PAGE_VIEW.TRANSCRIPT && <UploadTranscript />}
            </div>
          </div>
        ) : (
          <LoaderPage />
        )}
      </EventDelegationComponent>
    </>
  );
};
